import { render, staticRenderFns } from "./ItemSrcControl.vue?vue&type=template&id=630ea274&scoped=true&"
import script from "./ItemSrcControl.vue?vue&type=script&lang=js&"
export * from "./ItemSrcControl.vue?vue&type=script&lang=js&"
import style0 from "./ItemSrcControl.vue?vue&type=style&index=0&id=630ea274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630ea274",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ui-spec-md/ui-spec-md/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('630ea274', component.options)
    } else {
      api.reload('630ea274', component.options)
    }
    module.hot.accept("./ItemSrcControl.vue?vue&type=template&id=630ea274&scoped=true&", function () {
      api.rerender('630ea274', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UISpec/ScreenEditor/Toolbar/ItemSrcControl.vue"
export default component.exports